import React from 'react';
import classNames from 'classnames';
import { Stack, StackProps } from '@moda/om';
import { SizeInventoryFragment } from '../../generated/types';
import { SizeSelectorItem } from './SizeSelectorItem';
import './SizeSelectorList.scss';

type Props = Omit<StackProps, 'space' | 'onSelect'> & {
  sizes: SizeInventoryFragment[];
  sizeEquivalents: string[][];
  disableSizeMapping: boolean;
  selectedSize: SizeInventoryFragment | null;
  onSelect: (size: SizeInventoryFragment) => void;
};

export const SizeSelectorList: React.FC<Props> = ({
  className,
  sizes,
  sizeEquivalents,
  disableSizeMapping,
  selectedSize,
  onSelect,
  ...rest
}) => (
  <Stack className={classNames('SizeSelectorList', className)} space={0} {...rest}>
    {sizes.map(size => (
      <SizeSelectorItem
        key={size.size}
        className="SizeSelectorList__item"
        data-test-id="size-selector-item"
        data-test-size={size.size}
        data-test-sellable={size.canSell}
        data-test-available={size.canSell}
        data-test-selected={selectedSize?.size == size.size}
        size={size}
        sizeEquivalents={sizeEquivalents}
        disableSizeMapping={disableSizeMapping}
        selected={selectedSize?.size === size.size}
        onClick={() => onSelect(size)}
      />
    ))}
  </Stack>
);
